import { Component, Input } from '@angular/core';
import { JobHighlightItemComponent } from '../../shared/job-highlight-item/job-highlight-item.component';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { CardComponent } from '../../card/card.component';
import { Job } from '../../../models/job.model';
import { LanguageRoutingService } from '../../../services/language-routing.service';
import { getJobEmploymentTypes } from 'libs/shared/src/lib/i18n/job-employment-types';
import { getJobWorkplaceTypes } from 'libs/shared/src/lib/i18n/job-workplace-types';

@Component({
  selector: 'app-job-apply-sidebar',
  templateUrl: './job-apply-sidebar.component.html',
  styleUrls: ['./job-apply-sidebar.component.scss'],
  imports: [CommonModule, TranslocoModule, CardComponent, JobHighlightItemComponent],
  standalone: true,
})
export class JobApplySidebarComponent {
  @Input() job: Job | null = null;

  constructor(private languageRoutingService: LanguageRoutingService, private translocoService: TranslocoService) {}

  getLocalizedRoute(path: string): string {
    return this.languageRoutingService.getLocalizedRoute(path);
  }

  get currentLanguage(): string {
    return this.translocoService.getActiveLang();
  }

  getEmploymentTypeDisplay(type: string | string[] | undefined): string {
    if (!type || (Array.isArray(type) && type.length === 0)) {
      return this.translocoService.translate('common.notSpecified');
    }

    // Get current language and employment type translations
    const currentLang = this.translocoService.getActiveLang() as 'sk' | 'en' | 'cz';
    const employmentTypes = getJobEmploymentTypes(currentLang);

    // Convert to array if string
    const typeArray = Array.isArray(type) ? type : [type];

    // Translate each type
    const translatedTypes = typeArray.map((key) => {
      const translated = employmentTypes.jobEmploymentTypes[key as keyof typeof employmentTypes.jobEmploymentTypes];
      // Fallback to formatted key if translation not found
      return (
        translated ||
        key
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    });

    return translatedTypes.join(', ');
  }

  getWorkplaceTypeDisplay(placeOfWork: string | string[] | undefined): string {
    if (!placeOfWork || (Array.isArray(placeOfWork) && placeOfWork.length === 0)) {
      return this.translocoService.translate('common.notSpecified');
    }

    // Get current language and workplace type translations
    const currentLang = this.translocoService.getActiveLang() as 'sk' | 'en' | 'cz';
    const workplaceTypes = getJobWorkplaceTypes(currentLang);

    // Convert to array if string
    const placeArray = Array.isArray(placeOfWork) ? placeOfWork : [placeOfWork];

    // Translate each workplace type
    const translatedPlaces = placeArray.map((key) => {
      const translated = workplaceTypes.jobWorkplaceTypes[key.toLowerCase() as keyof typeof workplaceTypes.jobWorkplaceTypes];
      // Fallback to formatted key if translation not found
      return (
        translated ||
        key
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    });

    return translatedPlaces.join(', ');
  }
}
